export default __webpack_public_path__ + "static/media/gallery_07.683b2c1c.jpg";